
// ── Remembering a dismissal ──────────────────────────────────────────────────
// The dialog opens itself for an org with no policies, so a "no thanks" has to stick: an admin
// who decided to author their own policies should not meet it again on every visit. Per org,
// because the answer is about that org. Both halves are try/catch'd - a private window or
// blocked site data throws on access, and the only cost of losing the note is being asked once
// more. The header button is always there, so nothing is unreachable either way.
export function baselineDismissedKey(orgId: string): string {
  return `tm.policy.baseline.dismissed.${orgId}`
}

export function baselineDismissed(orgId: string): boolean {
  try {
    return localStorage.getItem(baselineDismissedKey(orgId)) === '1'
  } catch {
    return false
  }
}

export function rememberBaselineDismissed(orgId: string): void {
  try {
    localStorage.setItem(baselineDismissedKey(orgId), '1')
  } catch {
    // Nothing to do: the dialog is one-shot per mount anyway.
  }
}
